import { logSignInEvent, logSignUpEvent } from 'state/amplitude';
import { AuthenticationMethod, AuthenticationPhases } from 'state/amplitude/constants';
import { ModalAuthScreen } from 'state/auth/types';

export const authLogCancel = (message: string, page: ModalAuthScreen) => {
  const phase = AuthenticationPhases.CANCEL;

  if (page === ModalAuthScreen.SIGN_UP) {
    logSignUpEvent({
      phase,
      message,
    });
  }

  if (page === ModalAuthScreen.OTP) {
    logSignInEvent({
      phase,
      message,
      authenticationMethod: AuthenticationMethod.OTP,
    });
  }
};
